import { useCallback, useEffect, useState, useRef } from 'react';

import formatDistance from 'date-fns/formatDistance';
import pt from 'date-fns/locale/pt';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Actions from '~/components/Actions';
import Button from '~/components/Button';
import Header from '~/components/Header';
import Pagination from '~/components/Pagination';
import Table from '~/components/Table';
import TableActions from '~/components/TableActions';
import PrivateLayout from '~/layouts/Private';
import api from '~/services/api';
import masks from '~/utils/masks';

import Form from './Form';
import { Container, Capitalize } from './styles';

const INITIAL_PENSION_TYPES = {
  data: [],
  page: 0,
  perPage: 0,
  total: 0,
  lastPage: 0,
};

const LodgingPensionType = () => {
  const { id } = useParams();

  const formRef = useRef();

  const [pensionsType, setPensionTypes] = useState(INITIAL_PENSION_TYPES);

  const getTypePensions = useCallback(
    async (page = 1) => {
      try {
        const response = await api.get(
          `lodgings/${id}/pension-types?page=${page}&perPage=10&active=true&orderBy=updated_at DESC`
        );

        setPensionTypes(response.data);
      } catch (error) {
        toast.error('Erro ao buscar tipos de pensões...');
        setPensionTypes(INITIAL_PENSION_TYPES);
      }
    },
    [id]
  );

  useEffect(() => {
    getTypePensions();
  }, [getTypePensions]);

  const handleClickOpenForm = () =>
    formRef.current.setData({
      type: 'C',
    });

  const handleClickEdit = (data) => formRef.current.setData(data);

  const handleOnCloseForm = (reload) => {
    if (reload) getTypePensions();
  };

  const columns = [
    {
      key: 'description',
      label: 'Nome',
      format: (name) => <Capitalize>{name}</Capitalize>,
    },
    {
      key: 'price_chd',
      label: 'Taxa CHD (R$)',
      align: 'right',
      format: (value) => masks.currency(value),
    },
    {
      key: 'updated_at',
      label: 'Atualizado',
      format: (value) =>
        formatDistance(new Date(value), new Date(), {
          locale: pt,
          addSuffix: true,
        }),
    },
    {
      label: '',
      width: 50,
      format: (detail) => {
        return <TableActions onEdit={() => handleClickEdit(detail)} />;
      },
    },
  ];

  return (
    <PrivateLayout>
      <Container>
        <Header title="Tipos de pensão" total={pensionsType.total} />
        <Actions align="flex-end">
          <Button label="Novo tipo de pensão" onClick={handleClickOpenForm} />
        </Actions>
        <Form ref={formRef} onClose={handleOnCloseForm} />
        <Table columns={columns} rows={pensionsType.data} />
        <Pagination
          onChange={getTypePensions}
          page={pensionsType.page}
          perPage={pensionsType.perPage}
          total={pensionsType.total}
          lastPage={pensionsType.lastPage}
          position="flex-end"
        />
      </Container>
    </PrivateLayout>
  );
};

export default LodgingPensionType;
